import { EStringOp } from '@src/emp-3.0/types';
import { IBlockEventData, IBlockEventRuleItem } from '@src/common/types/empTypes';

import { scaledBlockRuleTagKeyOptions } from '../constant/constant';

export const getDefaultBlockEventRuleItem = (): IBlockEventRuleItem => {
  return {
    key: scaledBlockRuleTagKeyOptions[0].value,
    op: EStringOp.CONTAINS,
    value: [],
  };
};

export const getDefaultBlockEventData = (): IBlockEventData => {
  return {
    event_name: undefined,
    block_rules: [],
    description: undefined,
    block_timestamp: undefined,
    block_by: undefined,
    related: [],
  };
};
